"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Title3: function() {
        return _Title3.Title3;
    },
    title3ClassNames: function() {
        return _useTitle3Stylesstyles.title3ClassNames;
    }
});
const _Title3 = require("./Title3");
const _useTitle3Stylesstyles = require("./useTitle3Styles.styles");
